import { ComponentType, Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P) => (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// GENERAL
export const HomePage = Loadable(lazy(() => import('../pages/main/home/HomePage')));
export const ProjectsPage = Loadable(lazy(() => import('../pages/main/projects/ProjectsPage')));
export const CanvassingQAPage = Loadable(
  lazy(() => import('../pages/main/canvassing-qa/CanvassingQAPage'))
);
export const ReportsPage = Loadable(lazy(() => import('../pages/main/reports/ReportsPage')));
export const AdminPage = Loadable(lazy(() => import('../pages/main/admin/AdminPage')));

// LISTS
export const ListsPage = Loadable(lazy(() => import('../pages/main/data/lists/ListsPage')));
export const ListEditPage = Loadable(lazy(() => import('../pages/main/data/lists/ListEditPage')));

// DATA
export const DataPage = Loadable(lazy(() => import('../pages/main/data/DataPage')));

// CRM
export const CrmContactsPage = Loadable(lazy(() => import('../pages/main/crm/CrmContactsPage')));

// MESSAGING
export const MessagesPage = Loadable(lazy(() => import('../pages/main/messaging/MessagesPage')));
export const SurveyBuilderPage = Loadable(
  lazy(() => import('../pages/main/messaging/surveys/SurveyBuilderPage'))
);
export const TextEditPage = Loadable(
  lazy(() => import('../pages/main/messaging/texts/TextEditPage'))
);
export const VoicemailEditPage = Loadable(
  lazy(() => import('../pages/main/messaging/voicemails/VoicemailEditPage'))
);
export const TextConversationsPage = Loadable(
  lazy(() => import('../pages/main/conversations/TextConversationsPage'))
);
export const ConditionalSurveyEditPage = Loadable(
  lazy(() => import('../pages/main/messaging/surveys/ConditionalSurveyEditPage'))
);
export const ConditionalTextEditPage = Loadable(
  lazy(() => import('../pages/main/messaging/texts/ConditionalTextEditPage'))
);

// SETTINGS
export const TeamPage = Loadable(lazy(() => import('../pages/main/settings/team/TeamPage')));
export const OrganizationSettingsPage = Loadable(
  lazy(() => import('../pages/main/settings/organization/OrganizationSettingsPage'))
);
export const OrganizationCreationPage = Loadable(
  lazy(() => import('../pages/main/settings/organization/OrganizationCreationPage'))
);
export const OrganizationUpdatePage = Loadable(
  lazy(() => import('../pages/main/settings/organization/OrganizationUpdatePage'))
);
export const RegistrationPage = Loadable(
  lazy(() => import('../pages/main/settings/registration/RegistrationPage'))
);

export const CampaignsPage = Loadable(lazy(() => import('../pages/main/campaigns/CampaignsPage')));

export const VFUpdatesPage = Loadable(lazy(() => import('../pages/main/VFUpdatesPage')));

// MISC
export const NoOrganizationPage = Loadable(lazy(() => import('../pages/main/NoOrganizationPage')));
export const BlankPage = Loadable(lazy(() => import('../pages/main/BlankPage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));
export const SignUpWizardPage = Loadable(lazy(() => import('../pages/signUp/SignUpWizardPage')));
export const SignUpWizardSuccessPage = Loadable(
  lazy(() => import('../pages/signUp/SignUpWizardSuccessPage'))
);
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));

// PRE-ORG AND RELATIONAL
export const EmailNotVerifiedPage = Loadable(
  lazy(() => import('../pages/main/EmailNotVerifiedPage'))
);
export const PendingOrgInvitationsPage = Loadable(
  lazy(() => import('../pages/main/PendingOrgInvitationsPage'))
);
export const RelationalProofPage = Loadable(
  lazy(() => import('../pages/relational/RelationalProofPage'))
);
export const RelationalProofSuccessPage = Loadable(
  lazy(() => import('../pages/relational/RelationalProofSuccessPage'))
);
